import { useCallback, useEffect, useState } from "react";

export default function useFetch() {


  const [response, setResponse] = useState(null)
  const [error, setError] = useState(null)

  let api = `${process.env.REACT_APP_API}/api`


  const post = (route, params = null, invalid = null, after = null, error = null) => {

    let body = new FormData()
    let status
    if (params) {
      Object.keys(params).forEach(key => {
        body.append(key, params[key])
      })
    }

    fetch(`${api}${route}`, {
      method: 'POST',
      body
    }).then(res => {

      status = res.status
      return res.json()

    }).then(data => {

      if (status !== 200) {
        setError(data)
        if (invalid) {
          invalid(data)
        }
      } else {
        setResponse(data)
        if (after) {
          after(data)
        }
      }
      
    }).catch(err => {
      setError(err)

      if (error) {
        error(err)
      }

      console.error(err)
    })

  }

  const get = (route, params = null, invalid = null, after = null, error = null) => {

    let url = new URL(`${api}${route}`)
    let urlQuery = url.searchParams;
    let status

    if (params) {
      Object.keys(params).forEach(key => {
        urlQuery.append(key, params[key])
      })
    }

    url = url.toString()

    fetch(url, {
      method: 'GET'
    }).then(res => {

      status = res.status
      return res.json()

    }).then(data => {

      if (status !== 200) {
        setError(data)
        if (invalid) {
          invalid(data)
        }
      } else {
        setResponse(data)
        if (after) {
          after(data)
        }
      }
      


    }).catch(err => {
      setError(err)

      if (error) {
        error(err)
      }

      console.error(err)
    })
  }


  const del = (route, params = null,invalid=null, after = null, error = null) => {
    params.method = 'delete'

    post(route, params,invalid, after, error)
  }

  const update = (route, params = null, invalid=null,after = null, error = null) => {
    params.method = 'put'

    post(route, params, invalid,after, error)
  }

  return {
    post,
    get,
    del,
    update,
    response,
    error
  }

}
